<div class="c-gp-jumbotron {{className}}">
	{{#if gridType === 'type1'}}
		<img class="jumbotron_grid"
			width="1440"
			height="532"
			src="{{@shared.assetsHost}}/img/globalping/globalping-grid-type-1.svg">
	{{elseif gridType === 'type2'}}
		<img class="jumbotron_grid"
			width="1440"
			height="600"
			src="{{@shared.assetsHost}}/img/globalping/globalping-grid-type-2.svg">
	{{elseif gridType === 'type3'}}
		<div class="grid-type-3">
			<div class="grid-type-3_under-header"></div>

			<div class="grid-type-3_grid-wrapper">
				<img class="jumbotron_grid"
					width="1150"
					height="689"
					src="{{@shared.assetsHost}}/img/globalping/globalping-grid-type-3.svg">
			</div>

			<div class="grid-type-3_gradient"></div>
		</div>
	{{elseif gridType === 'type4'}}
		<img class="jumbotron_grid"
			width="1150"
			height="689"
			src="{{@shared.assetsHost}}/img/globalping/globalping-grid-type-4.svg">
	{{/if}}

	<div class="jumbotron_blur">
		<div class="jumbotron_blur_circle-one"></div>
		<div class="jumbotron_blur_circle-two"></div>
	</div>
</div>
